import { render, staticRenderFns } from "./InvoiceMgmt.vue?vue&type=template&id=bb2e4cde"
import script from "./InvoiceMgmt.vue?vue&type=script&lang=js"
export * from "./InvoiceMgmt.vue?vue&type=script&lang=js"
import style0 from "./InvoiceMgmt.vue?vue&type=style&index=0&id=bb2e4cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports